//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'small',
          'inherit'
        ].includes(value)
      }
    },
    invert: { type: Boolean, default: false }
  },
  computed: {
    classes () {
      return [
        {
          regular: 't-h4 font-light',
          small: 't-h5 font-normal',
          inherit: 'LineLink--inherit'
        }[this.size],
        {
          'LineLink--inverted': this.invert
        }]
    }
  }
}
